<template>
  <header id="header">
    <div class="container">
      <div class="logo" v-if="sellerInfo.rooftopLogo">
        <img :src="sellerInfo.rooftopLogo" style="width: 100%; object-fit: contain" />
      </div>
      <div class="main-nav">
        <div class="profile-user">
          <div class="user-information">
            <h2 v-if="sellerInfo.fullName" class="user-name">
              {{ sellerInfo.fullName }}
            </h2>
            <p v-if="sellerInfo.rooftopName" class="user-car-mark">
              {{ sellerInfo.rooftopName }}
            </p>
          </div>
          <figure class="media">
            <img
              v-if="sellerInfo.photo && !hasError"
              :src="sellerInfo.photo"
              alt="Seller photo"
              @error="hasError = true"
            />
            <i v-else class="fas fa-user" />
          </figure>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheNavbar',
  props: {
    sellerInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
};
</script>

<style lang="scss" scoped>
#header {
  position: sticky;
  z-index: 500;

  .container {
    @media (max-width: 575.98px) {
      padding-left: 15px;
      padding-right: 15px;
      justify-content: center;
    }
  }

  .logo {
    position: initial !important;
    max-width: 320px;
  }

  .main-nav {
    .fa-user {
      color: #aaa;
      font-size: 22px;
    }
  }

  .user-name {
    font-size: 14px;
    letter-spacing: 0;
    font-weight: 400;
    text-transform: initial;
    color: #212529;
    font-weight: bold;
  }

  .profile-user {
    min-width: 190px !important;
  }

  .user-car-mark {
    @media (max-width: 575.98px) {
      font-weight: 300;
    }
  }

  .profile-user .media {
    img {
      border: none;
    }

    @media (max-width: 575.98px) {
      padding: 0px 0px 0px 7px !important;
      margin-left: 7px !important;
    }
  }
}
</style>
